import type { ProductListItemDto } from '@/services/platform/api/model';
import { SoldOutTag } from '../banners/sold-out-tag';

export function ShopProductListView3Grid({
  products,
  onProductClick,
}: {
  products: ProductListItemDto[];
  onProductClick: (publicGuid: string | undefined) => void;
}) {
  return (
    <div className="grid grid-cols-3 gap-x-2 gap-y-6 px-4 pt-8">
      {products.map(p => (
        <button
          key={p.publicGuid}
          type="button"
          onClick={() => onProductClick(p.publicGuid)}
          className="flex h-43.5 flex-col gap-2"
        >
          <div className="bg-jncquoi-neutral-200 relative min-h-px flex-1 overflow-hidden">
            {p.imageUrl && (
              <img
                src={p.imageUrl}
                alt={p.title ?? ''}
                className="absolute inset-0 h-full w-full object-cover"
              />
            )}
            {p.soldOut && (
              <>
                <div className="absolute inset-0 bg-[rgba(204,204,204,0.6)]" />
                <SoldOutTag className="absolute top-2 left-2" />
              </>
            )}
          </div>
          {p.vendor && (
            <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 shrink-0 text-[10px] leading-none font-semibold tracking-[0.5px] uppercase">
              {p.vendor}
            </p>
          )}
        </button>
      ))}
    </div>
  );
}
